import { ErrorBoundary_default } from './chunk-NJFJDBQA.js';
import { ThemeProvider } from './chunk-J2FXRRBJ.js';
import { __spreadValues } from './chunk-2FEJBM4N.js';
import { Snackbar, Alert, CircularProgress, Drawer as Drawer$1, Box, Stack, Skeleton } from '@mui/material';
import React from 'react';

function Drawer(props) {
  const {
    open,
    children,
    anchor = "right",
    onClose,
    loading,
    snackbarLoadingText,
    containerSx
  } = props;
  return /* @__PURE__ */ React.createElement(ErrorBoundary_default, { componentName: "Drawer" }, /* @__PURE__ */ React.createElement(ThemeProvider, null, /* @__PURE__ */ React.createElement(
    Snackbar,
    {
      open: loading && !open,
      anchorOrigin: { vertical: "top", horizontal: "right" }
    },
    /* @__PURE__ */ React.createElement(Alert, { severity: "info", icon: /* @__PURE__ */ React.createElement(CircularProgress, { size: "20px" }) }, snackbarLoadingText || "Loading")
  ), /* @__PURE__ */ React.createElement(
    Drawer$1,
    {
      open,
      anchor,
      onClose: (e, reason) => {
        if (onClose) {
          onClose(reason);
        }
      }
    },
    /* @__PURE__ */ React.createElement(
      Box,
      {
        sx: __spreadValues({
          height: "100%",
          overflow: "auto",
          width: loading ? "300px" : "auto",
          p: 2
        }, containerSx)
      },
      loading && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Stack, { direction: "column", spacing: 2, sx: { width: "100%" } }, /* @__PURE__ */ React.createElement(Skeleton, { variant: "text" }), /* @__PURE__ */ React.createElement(Skeleton, { variant: "text", width: "150px" }), /* @__PURE__ */ React.createElement(Skeleton, { variant: "text", width: "100px" }), /* @__PURE__ */ React.createElement(Skeleton, { variant: "rounded", height: "200px" }), /* @__PURE__ */ React.createElement(Skeleton, { variant: "text", width: "150px" }), /* @__PURE__ */ React.createElement(Skeleton, { variant: "text", width: "100px" }), /* @__PURE__ */ React.createElement(Skeleton, { variant: "rounded", height: "200px" }), /* @__PURE__ */ React.createElement(Skeleton, { variant: "text", width: "150px" }), /* @__PURE__ */ React.createElement(Skeleton, { variant: "text", width: "100px" }), /* @__PURE__ */ React.createElement(Skeleton, { variant: "rounded", height: "200px" }))),
      !loading && children
    )
  )));
}
var Drawer_default = Drawer;

// src/components/Drawer/index.ts
var Drawer_default2 = Drawer_default;

export { Drawer_default2 as Drawer_default };
//# sourceMappingURL=chunk-IPTW4GUQ.js.map
//# sourceMappingURL=chunk-IPTW4GUQ.js.map